import Pqp from "../../3x1010/Pqp";

export default class MainLoop {

  static start() {
    MainLoop._init();
    MainLoop._loop(performance.now());
  }

  static subscribe(instance, callback = "paint", priority = 1) {
    instance._mainLoopUid = Pqp.newGuid();
    MainLoop._init();
    MainLoop._subscriptions[priority].push({ instance: instance, callback: callback });
  }

  static unsubscribe(instance) {
    for (let x = 0; x < MainLoop._subscriptions.length; x++) {
      let a = MainLoop._subscriptions[x];
      for (let y = 0; y < a.length; y++) {
        if (a[y].instance._mainLoopUid === instance._mainLoopUid) {
          MainLoop._subscriptions[x].splice(y, 1);
          break;
        }
      }
    }
  }

  static isRunning() {
    return MainLoop._started;
  }

  static stop() {
    MainLoop._started = false;
    cancelAnimationFrame(MainLoop._updateId);
  }
  static pause() {
    MainLoop.stop();
  }

  static resume() {
    MainLoop.start();
  }

  static _init() {
    if (MainLoop._inited) {
      return;
    }
    MainLoop._inited = true;
    for (let x = 0; x < 4; x++) {
      MainLoop._subscriptions.push(new Array());
    }
  }


  static _loop(currentDelta) {
    MainLoop._started = true;
    MainLoop._updateId = requestAnimationFrame(MainLoop._loop.bind(MainLoop));
    let delta = currentDelta - MainLoop._previousDelta;
    if (MainLoop.FPS_LIMIT && delta < Math.floor(1000 / MainLoop.FPS_LIMIT)) {
      return;
    }
    MainLoop._dispatch();
    MainLoop._previousDelta = currentDelta;
  }

  static _dispatch() {
    for (let x = 0; x < MainLoop._subscriptions.length; x++) {
      let a = MainLoop._subscriptions[x];
      for (let y = 0; y < a.length; y++) {
        a[y].instance[a[y].callback]();
      }
    }
  }

}

MainLoop._updateId = -1;
MainLoop._previousDelta = 0;
MainLoop._inited = false;
MainLoop._started = false;

MainLoop.FPS_LIMIT = 60;
MainLoop.PRIORITY_MAIN = 0;
MainLoop.PRIORITY_HIGH = 1;
MainLoop.PRIORITY_NORMAL = 2;
MainLoop.PRIORITY_LOW = 3;

MainLoop._subscriptions = new Array();

